<template>
  <div
    id="main-menu"
    :class="open ? 'menu-open' : 'menu-close'"
    v-click-outside="closeDrawer"
  >
    <div class="close-icon" @click="open = false">
      <img src="@/assets/i/menu-close.svg" class="img-fluid" />
    </div>
    <nav role="main">
      <div class="logo" @click="open = !open">
        <img v-if="!open" src="@/assets/i/simbolo.png" class="img-fluid" />
        <img v-if="open" src="@/assets/i/logoClaim.png" class="img-fluid" />
      </div>
      <ul v-if="showSideMenu === 'dashboard_menu'" @click="clearSearch">
        <web-menu-item v-for="(item, key) in menu" :key="key" :item="item" />
      </ul>
      <ul v-if="showSideMenu === 'brand_menu'" @click="clearSearch">
        <web-menu-item
          v-for="(item, key) in menuBrand"
          :key="key"
          :item="item"
        />
      </ul>
      <ul v-if="showSideMenu === 'admin_menu'">
        <div
          v-for="(item, key) in menuAdmin"
          :key="key"
          @click="clearSearch"
        >
          <web-menu-item :item="item" />
        </div>
      </ul>
      <ul v-if="showSideMenu === 'printer_menu'">
        <div
          v-for="(item, key) in menuPrinter"
          :key="key"
          @click="clearSearch"
        >
          <web-menu-item :item="item" />
        </div>
      </ul>
    </nav>
  </div>
</template>
<script>
import menu from "@/data/menu.js";
import menuAdmin from "@/data/menu_admin.js";
import menuPrinter from "@/data/menu_printer.js";
import menuBrand from "@/data/brand_menu.js";
import WebMenuItem from "./WebMenuItem";

export default {
  name: "web-menu",
  props: ["showSideMenu"],
  components: {
    WebMenuItem
  },
  data() {
    return {
      menu,
      menuAdmin,
      menuBrand,
      menuPrinter,
      open: false
    };
  },
  methods: {
    clearSearch() {
      this.$session.clear();
    },
    toggleSideBar() {
      setTimeout(() => {
        this.open = !this.open;
      }, 200);
    },
    closeDrawer() {
      if (this.open) {
        this.open = false;
      }
    },
    showCurrentMenu(current) {
      return localStorage.getItem("dashboard_type") === current;
    }
  },
  computed: {
    role: function() {
      return this.$store.state.user.role;
    },
    brandMenu: {
      get() {
        return this.$store.getters.brandMenu;
      },
      set(data) {
        this.$store.dispatch("setBrandMenu", data);
      }
    }
  },
  mounted() {
    let type = localStorage.getItem("dashboard_type") || "dashboard_menu";
    this.showCurrentMenu(type);
  }
};
</script>
